import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach session token from localStorage as fallback (for testing & non-cookie envs)
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("monzal_session_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
